<template>
  <div class="sc-object-card__list-item__wrapper">
    <r-text type="caption">
      {{ $t(field.type) }}
    </r-text>
    <r-text v-if="field.type === 'phase' || field.type === 'closed_line_count'">
      {{ field.value }}
    </r-text>
    <r-text v-else-if="checkDateTimeType(field.type)">
      {{ getDateTime(field.value) }}
    </r-text>
    <r-text v-else-if="field.type === 'geometry'">
      {{ getGeom(field.value) }}
    </r-text>
    <r-text v-else>
      {{ field.type !== "speed" ? $t(`${field.value}`) : field.value }}
    </r-text>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    field: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  methods: {
    getDateTime(val) {
      return moment(val).format("DD.MM.YY HH:mm");
    },
    checkDateTimeType(val) {
      switch (val) {
        case "start_time":
        case "end_time":
        case "gps_time":
        case "time":
          return true;
        default:
          return false;
      }
    },
    getGeom(val) {
      const geom = JSON.parse(val);

      return `X: ${geom[0].toFixed(5)}, Y: ${geom[1].toFixed(5)}`;
    }
  }
};
</script>

<style lang="scss">
.sc-object-card__list-item__wrapper {
  position: relative;
}
</style>

<i18n>
{
  "ru": {
    "true": "Работает",
    "false": "Не работает",
    "0": "-",
    "location": "Месторасположение",
    "type": "Тип",
    "code": "Код",
    "phase": "Фаза",
    "status": "Статус",
    "mode": "Мод",
    "report": "Отчет",
    "voltage": "Вольтаж",
    "reg_number": "Рег.номер",
    "organization": "Организация",
    "event_class": "Тип события",
    "ДТП": "ДТП",
    "Мероприятия": "Событие",
    "Ремонтные работы": "Дорожные работы",
    "contractor": "Контрактор",
    "contact": "Контакт",
    "contract": "Контракт",
    "period": "Период",
    "object_id": "ИД объекта",
    "null": "Не указано",
    "place": "Местоположение",
    "afterDate": "Дата и время начала",
    "beforeDate": "Дата и время окончания",
    "disposition": "Распорядитель",
    "description": "Описание",
    "fullName": "ФИО",
    "executor": "Исполнитель",
    "phone": "Телефон",
    "events": "События",
    "geometry": "Координаты",
    "comment": "Комментарий",
    "route_number": "Номер маршрута",
    "route_name": "Название маршрута",
    "minutes_to_arrive": "Минут до прибытия"
  },
  "en": {
    "true": "Work",
    "false": "Error",
    "0": "Error",
    "location": "Location",
    "type": "Type",
    "code": "Code",
    "phase": "Phase",
    "status": "Status",
    "mode": "Mode",
    "report": "Report",
    "voltage": "Voltage",
    "reg_number": "Reg.number",
    "organization": "Organization",
    "event_class": "Event type",
    "ДТП": "Accident",
    "Мероприятия": "Event",
    "Ремонтные работы": "Road work",
    "contractor": "Contractor",
    "contact": "Contact",
    "contract": "Contract",
    "period": "Period",
    "object_id": "Object ID",
    "null": "No data",
    "place": "Place",
    "afterDate": "Start date and time",
    "beforeDate": "End date and time",
    "description": "Description",
    "disposition": "Disposer",
    "fullName": "Full name",
    "executor": "Executor",
    "phone": "Phone",
    "events": "Events",
    "geometry": "Geometry",
    "comment": "Comment",
    "route_number": "Route Number",
    "route_name": "Route",
    "minutes_to_arrive": "Minutes to arrive"
  }
}
</i18n>
